import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useRef, useState } from 'react';
const SetDetailContext = createContext(null);
const DetailLabelContext = createContext(null);
export function BreadcrumbDetailProvider({ children }) {
    const [entry, setEntry] = useState(null);
    return (
    // Два контекста: страницы читают только стабильный сеттер и не
    // перерисовываются, когда меняется подпись.
    _jsx(SetDetailContext.Provider, { value: setEntry, children: _jsx(DetailLabelContext.Provider, { value: entry?.label ?? null, children: children }) }));
}
/**
 * Задаёт подпись детальной крошки, пока страница смонтирована. `null`,
 * `undefined` или пустая строка — крошки нет (например, пока данные грузятся;
 * тогда шелл покажет `ModuleRoute.label`). Уход со страницы её снимает.
 */
export function useBreadcrumbDetail(label) {
    const setDetail = useContext(SetDetailContext);
    // Владелец записи: уборка старой страницы не должна стереть подпись новой,
    // в каком бы порядке React ни вызвал эффекты при переходе.
    const owner = useRef({}).current;
    const text = label?.trim() ? label.trim() : null;
    useEffect(() => {
        if (!setDetail || text === null)
            return;
        setDetail(() => ({ owner, label: text }));
        return () => setDetail((cur) => (cur?.owner === owner ? null : cur));
    }, [setDetail, owner, text]);
}
/** Текущая подпись детальной крошки или `null`. Читает шелл. */
export function useBreadcrumbDetailLabel() {
    return useContext(DetailLabelContext);
}
//# sourceMappingURL=breadcrumb-detail.js.map